import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=7e4a8b5e"
import script from "./menu.ts?vue&type=script&lang=js&external"
export * from "./menu.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports